import { FAIconName } from '@equip.health/ui';

export const GROUP_CLASS_ACCORDION_TOP_LEVEL_ID =
  'add-edit-group-class-accordion';

export interface GroupClassBaseFieldProps<T> {
  isEditMode?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  onChange: (value: T) => void;
  value: T;
  leftIcon?: FAIconName;
  placeholder?: string;
}
